// gimme: conversations-inbox-ui 06/04/2020 c274e8ac5510b62b817eb74db200bc9802a2508d
'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
const WIDTH = 550;
const MarkAsSpamPrompt = props => {
  const {
    onConfirm,
    onReject
  } = props;
  return /*#__PURE__*/_jsx(ConfirmModal, {
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-thread-view.filtered-threads.mark-as-spam-prompt.confirm"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-thread-view.filtered-threads.mark-as-spam-prompt.body"
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-thread-view.filtered-threads.mark-as-spam-prompt.header"
    }),
    onConfirm: onConfirm,
    onReject: onReject,
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-thread-view.filtered-threads.mark-as-spam-prompt.cancel"
    }),
    width: WIDTH
  });
};
MarkAsSpamPrompt.displayName = 'MarkAsSpamPrompt';
MarkAsSpamPrompt.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired
};
export default MarkAsSpamPrompt;